//Function to show hide info popup
const popupFunction = () => {
  const popupOpener = document.querySelector(".db-0015-upsell-header-info");
  const popup = document.querySelector(".db-0015-upsell-header-info-popup");

  popupOpener.addEventListener("click", () => {
    popup.classList.toggle("active");
  });
};

//Get value for reduced badges
const getValue = () => {
  //Get value for badge
  const choosenCounter = document.querySelectorAll(
    `.db-0015-upsell-slider-product[data-type="variant"].active`,
  ).length;

  let value;
  if (choosenCounter === 1) {
    value = 10;
  } else if (choosenCounter > 1) {
    value = 15;
  } else {
    value = null;
  }

  return value;
};

//Function for badge
const badgeOffer = () => {
  //Remove the old badge if there is one
  const oldBadge = document.querySelector(".db-0015-upsell-badge");
  if (oldBadge) {
    oldBadge.remove();
  }

  const value = getValue();

  //If none are selected dont show a new badge
  if (value != null) {
    const badge = `
    <div class="db-0015-upsell-badge">
      <span>-${value}%</span>
    </div>
    `;

    //Insert badge
    const upsell = document.querySelector(".db-0015-upsell");
    upsell.insertAdjacentHTML("afterBegin", badge);
  }
};

//Get the cleanPrice
const getPrice = (price) => {
  const cleanedPrice = Number(
    price.textContent.replace(",", ".").replace("€", ""),
  );

  return cleanedPrice;
};

//Turn prices back to string
const transformPrice = (price) => {
  const transformedPrice = price.toFixed(2).toString().replace(".", ",");

  return transformedPrice;
};

//Price calculation
const priceCalc = () => {
  //Get all choosen elements
  const choosenProducts = document.querySelectorAll(
    '.db-0015-upsell-slider-product[data-id="current"], .db-0015-upsell-slider-product.active[data-id="upsell"]',
  );

  //Get overall price
  let fullPrice = null;
  choosenProducts.forEach((product) => {
    const price = product.querySelector(".db-0015-upsell-slider-product-price");

    const cleanPrice = getPrice(price);
    console.log(cleanPrice);

    fullPrice += cleanPrice;
  });

  //Remove the old badge if there is one
  const oldPrice = document.querySelector(".db-0015-upsell-footer-price");
  if (oldPrice) {
    oldPrice.remove();
  }

  //Get fullprice after discount
  const discountValue = getValue();
  if (discountValue != null) {
    const reducedValue = fullPrice * (1 - discountValue / 100);

    //Get the overall discount
    const overallDiscount = fullPrice - reducedValue;

    //Turn finished prices back to string
    const finishedFull = transformPrice(fullPrice);
    const finishedReduced = transformPrice(reducedValue);
    const finishedDiscount = transformPrice(overallDiscount);

    //Create price element
    const price = `
    <div class="db-0015-upsell-footer-price">
      <div class="db-0015-upsell-footer-price-text">
       <p>Summe</p>
      </div>
        <div class="db-0015-upsell-footer-price-values">
            <div class="db-0015-upsell-footer-price-offer">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.28093 0.939238C5.83928 0.168825 6.54344 -0.0655379 7.4393 0.0150218C8.25356 0.0882451 9.0797 0.0305184 9.99886 0.0305184C9.99886 1.27928 10.005 2.50676 9.98864 3.73395C9.98711 3.84807 9.85766 3.97546 9.76188 4.07115C7.75683 6.07444 5.74807 8.07405 3.8147 10C2.54924 8.7385 1.30058 7.49375 0 6.19724C1.6688 4.53567 3.45711 2.75513 5.28093 0.939238ZM6.71626 1.58446C6.10511 2.22292 6.05183 2.86115 6.56331 3.41647C6.98688 3.87636 7.67723 3.93051 8.2064 3.54535C8.73232 3.16257 8.87371 2.49662 8.54569 1.9473C8.17029 1.31863 7.56528 1.17123 6.71626 1.58446Z" fill="#34A853"/>
            </svg>
            <span>Spare ${finishedDiscount} €</span>
            </div>
            <div class="db-0015-upsell-footer-price-breaker"></div>
            <span class="db-0015-upsell-footer-price-reduced">${finishedReduced} €</span>
            <span class="db-0015-upsell-footer-price-full">${finishedFull} €</span>
        </div>
    </div>
    `;

    const priceContainer = document.querySelector(".db-0015-upsell-footer");
    priceContainer.insertAdjacentHTML("afterBegin", price);
  }
};

//Function for badge
const atcOffer = () => {
  //Remove the old badge if there is one
  const oldBadge = document.querySelector(".db-0015-upsell-footer-atc-badge");
  if (oldBadge) {
    oldBadge.remove();
  }

  const value = getValue();

  //If none are selected dont show a new badge
  const atc = document.querySelector(".db-0015-upsell-footer-atc");
  if (value != null) {
    const badge = `
    <div class="db-0015-upsell-footer-atc-badge">
      <span>-${value}%</span>
    </div>
    `;

    //Insert badge
    atc.classList.remove("disabled");
    atc.insertAdjacentHTML("beforeEnd", badge);
  }
};

//Function for the upsell products
const productFunctions = () => {
  const products = document.querySelectorAll(
    '.db-0015-upsell-slider-product[data-id="upsell"]',
  );

  products.forEach((product) => {
    product.addEventListener("click", () => {
      //Toggle active class
      product.classList.toggle("active");

      //Recalculate offer value
      badgeOffer();
      priceCalc();
      atcOffer();
    });
  });
};

//Function to set the upsell product values right
const upsellProduct = () => {
  const originalOptions = document.querySelectorAll(
    ".product-info__variant-picker fieldset",
  );

  const upsellProducts = document.querySelectorAll(
    ".db-0015-upsell-slider-product",
  );

  upsellProducts.forEach((product, productIndex) => {
    const upsellSelects = product.querySelectorAll(
      ".db-0015-upsell-options select",
    );

    upsellSelects.forEach((upsellSelect) => {
      const type = upsellSelect.dataset.type;

      const index = upsellSelect.dataset.position === "option1" ? 0 : 1;
      const originalOption = originalOptions[index];
      if (!originalOption) return;

      const checkedInput = originalOption.querySelector("input:checked");
      if (!checkedInput) return;

      const value = checkedInput.value;

      if (productIndex === 0) {
        // Take all options from the original element
        const optionToSelect = upsellSelect.querySelector(
          `option[value="${value}"]`,
        );
        if (optionToSelect) upsellSelect.value = value;
      } else if (type.includes("farbe")) {
        // Only color if it has one
        const hasColorOptions =
          upsellSelect.querySelectorAll("option").length > 1;
        if (hasColorOptions) {
          const optionToSelect = upsellSelect.querySelector(
            `option[value="${value}"]`,
          );
          if (optionToSelect) upsellSelect.value = value;
        }
      }

      //Fake change so imgs update
      upsellSelect.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
};

let UpsellBundleProduct = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
    this.selects = Array.from(this.querySelectorAll("select"));
    this.button = this.querySelector(
      ".db-0015-upsell-slider-product-content:has([data-toggle])",
    );
    this.error = this.querySelector("[data-error]");

    this.variants = this.querySelector("script");
    this.variant = {};
    this.image = this.querySelector("img");
  }
  async connectedCallback() {
    document.forms[this.form]?.addEventListener(
      "variant:change",
      this._onVariantChangedListener,
    );
    this.button?.addEventListener("click", this._onClick.bind(this));
    this.selects.forEach((select) =>
      select.addEventListener("change", this._onSelectChanged.bind(this)),
    );

    //We need the data to be loaded in json instead via liquid, there might be a rendering issue
    this.variants = JSON.parse(this.variants.innerText);
  }
  disconnectedCallback() {
    document.forms[this.form]?.removeEventListener(
      "variant:change",
      this._onVariantChangedListener,
    );

    this.button.removeEventListener("click", this._onClick.bind(this));
    this.selects.forEach((select) =>
      select.removeEventListener("change", this._onSelectChanged.bind(this)),
    );
  }
  get form() {
    return this.getAttribute("form");
  }
  get price() {
    return parseFloat(this.dataset?.price ?? 0);
  }
  get color() {
    return this.dataset?.color ?? false;
  }
  get id() {
    return parseInt(this.dataset?.productId) ?? false;
  }
  set id(value) {
    this.dataset.productId = value;
  }
  get variantId() {
    return parseInt(this.dataset?.variantId) ?? false;
  }
  set variantId(value) {
    this.dataset.variantId = value;
  }
  get type() {
    return this.dataset?.type ?? false;
  }
  _sendEvents() {
    //Update Bundle Price
    document.documentElement.dispatchEvent(
      new CustomEvent("upsell-bundle:updated", {
        bubbles: true,
        details: {
          variant: this.variant,
        },
      }),
    );
  }
  _onClick(event) {
    //On Click shouldn't interfere with normal products
    if (this.type === "product") {
      event.preventDefault();
      return;
    }

    this.classList.toggle("active");
    this.button.classList.toggle("active");

    this._sendEvents();
  }
  _onSelectChanged(event) {
    const { value, id } = event.target;
    const label = this.querySelector(`[for="${id}"]`);
    if (label) {
      label.innerText = value === "0" ? "-" : value;
    }

    // Variant id swap
    const values = this.selects.map((select) => select.value);
    const options = values.filter((option) => option !== "0");
    const success = options.length === values.length;

    this.variant =
      this.variants.find(
        (product) =>
          product.options.every((item) => values.includes(item)) &&
          values.every((item) => product.options.includes(item)),
      ) ?? false;

    //Check if avalible
    if (this.selects.length === 1) {
      // Only one option
      const singleSelect = this.selects[0];
      for (const option of singleSelect.options) {
        const matchingVariant = this.variants.find((v) =>
          v.options.includes(option.value),
        );
        if (!matchingVariant || !matchingVariant.available) {
          option.classList.add("unavailable");
          option.disabled = true;
        } else {
          option.classList.remove("unavailable");
          option.disabled = false;
        }
      }
    } else if (this.selects.length > 1) {
      // More options — use "farbe" as anchor, everything else is the size/length select
      const colorSelect = this.selects.find(
        (select) => select.dataset.type === "farbe",
      );
      const sizeSelect = this.selects.find(
        (select) => select.dataset.type !== "farbe",
      );

      if (sizeSelect && colorSelect) {
        // Disable size/length options that are unavailable for the selected color
        for (const option of sizeSelect.options) {
          const matchingVariant = this.variants.find(
            (v) =>
              v.options.includes(option.value) &&
              v.options.includes(colorSelect.value),
          );
          if (!matchingVariant || !matchingVariant.available) {
            option.classList.add("unavailable");
            option.disabled = true;
          } else {
            option.classList.remove("unavailable");
            option.disabled = false;
          }
        }

        // Disable color options where ALL sizes are sold out
        for (const option of colorSelect.options) {
          if (option.value === "0") continue; // skip placeholder
          const hasAvailable = this.variants.some(
            (v) =>
              v.options.includes(option.value) && v.available,
          );
          if (!hasAvailable) {
            option.classList.add("unavailable");
            option.disabled = true;
          } else {
            option.classList.remove("unavailable");
            option.disabled = false;
          }
        }
      }
    }

    if (this.variant && this.variant.id) {
      this.variantId = this.variant.id;
    }

    // Show sold-out notice if any selected option is disabled (= unavailable)
    const soldOutNotice = this.querySelector("[data-sold-out]");
    if (soldOutNotice) {
      const hasUnavailableSelection = this.selects.some((select) => {
        if (select.value === "0") return false;
        const selectedOption = select.querySelector(`option[value="${select.value}"]`);
        return selectedOption && selectedOption.disabled;
      });
      // Also check: variant matched but not available (both options set, combo sold out)
      const variantSoldOut = this.variant && !this.variant.available;
      soldOutNotice.hidden = !hasUnavailableSelection && !variantSoldOut;
    }

    // Hide / Show Error
    this.error.hidden = success;
    this._sendEvents();

    // Img swap
    const colorSelect = this.selects.find(
      (select) => select.dataset.type === "farbe",
    );
    if (!colorSelect) return;

    const selectedColor = colorSelect.value;

    const colorVariant =
      this.variants.find((product) =>
        product.options.includes(selectedColor),
      ) ?? false;

    if (colorVariant && colorVariant.featured_image) {
      this.image.src = colorVariant.featured_image.src;
      this.image.srcset = colorVariant.featured_image.src;
    }

    //Check if all options are set
    //Compare all options that are not 0 with selected values
    /*const values = this.selects.map((select) => select.value);
    const options = values.filter((option) => option !== "0");

    const success = options.length === values.length;

    console.log(values);

    this.variant =
      this.variants.find(
        (product) =>
          product.options.every((item) => values.includes(item)) &&
          values.every((item) => product.options.includes(item)),
      ) ?? false;

    console.log(this.variant);
    if (this.variant !== undefined && this.variant && this.variant.id) {
      this.variantId = this.variant.id;
      this.image.src = this.variant.featured_image.src;
    }

    //Hide / Show Error
    this.error.hidden = success;
    this._sendEvents();*/
  }
  _onVariantChanged(event) {
    this.hidden = false;

    const { product, variant } = event.detail;

    if (!product || !variant) {
      console.error("DB-0015", "variant changed", "no product / variant");
      return;
    }

    if (this.type === "product") {
      this.variants = product.variants;
      this.variant = variant;
      this.variantId = variant.id;

      // Sync image (src + srcset)
      if (variant.featured_image) {
        this.image.src = variant.featured_image.src;
        this.image.srcset = variant.featured_image.src;
      }

      // Sync selects + labels to match PDP selection
      this.selects.forEach((select) => {
        const position = select.dataset.position;
        const optionValue = variant[position];
        if (optionValue && select.value !== optionValue) {
          select.value = optionValue;
          const label = this.querySelector(`[for="${select.id}"]`);
          if (label) label.innerText = optionValue;
        }
      });

      // Sync price
      const priceEl = this.querySelector(".db-0015-upsell-slider-product-price");
      if (priceEl && variant.price != null) {
        priceEl.textContent = (variant.price / 100).toFixed(2).replace(".", ",") + " €";
      }

      this._sendEvents();
    }
  }
};
if (!window.customElements.get("upsell-bundle-product")) {
  window.customElements.define("upsell-bundle-product", UpsellBundleProduct);
}

let UpsellBundleButton = class extends HTMLElement {
  static observedAttributes = ["coupon"];
  constructor() {
    super();
    this.disabled = true;
    this.selects = [];
    this.options = [];

    this.coupons = {
      10: "",
      15: "",
    };
  }
  connectedCallback() {
    this.addEventListener("click", this._onClick.bind(this));
    document.documentElement.addEventListener(
      "upsell-bundle:updated",
      this._onUpsellUpdated.bind(this),
    );
  }
  disconnectedCallback() {
    this.removeEventListener("click", this._onClick.bind(this));
    document.documentElement.removeEventListener(
      "upsell-bundle:updated",
      this._onUpsellUpdated.bind(this),
    );
  }
  async _updateCart(ids) {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) {
      console.error("DB-0015", "no cart");
      return;
    }

    const nhBundleTimestamp = Date.now().toString();

    const items = ids.map((id) => {
      return {
        id,
        quantity: 1,
        properties: {
          _DiscountId: `${nhBundleTimestamp}`,
        },
      };
    });

    console.log("updateCart", items);

    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items,
      }),
    });

    if (!response.ok) {
      throw Error("DB-0015 - error with add cart");
    }

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      }),
    );

    //Open cart
    drawer.show();
  }
  _onClick(event) {
    if (this.disabled) {
      return;
    }

    const ids = Array.from(
      document.querySelectorAll("upsell-bundle-product.active"),
    ).map((product) => product.variantId);
    this._updateCart(ids);
  }
  _onUpsellUpdated(event) {
    //Get all selects
    this.selects = Array.from(
      document.querySelectorAll(
        `upsell-bundle-product[data-type="variant"].active select`,
      ),
    );
    this.options = this.selects
      .map((select) => select.value)
      .filter((option) => option !== "0");

    const active =
      this.options.length > 0 && this.selects.length === this.options.length;
    this.disabled = !active;

    //Code for the ATC btn state and text
    const atcText = document.querySelector(".db-0015-upsell-footer-atc p");
    this.items = document.querySelectorAll(
      `upsell-bundle-product[data-type="variant"].active`,
    ).length;

    if (active) {
      this.removeAttribute("disabled");

      atcText.textContent = "Set Hinzufügen";
      atcOffer();
    } else {
      this.setAttribute("disabled", "disabled");

      if (this.items === 0) {
        atcText.textContent = "Auswählen und sparen";
      } else {
        atcText.textContent = "Größe auswählen";
      }
    }

    //Offer Badge functions
    badgeOffer();
  }
};
if (!window.customElements.get("upsell-bundle-button")) {
  window.customElements.define("upsell-bundle-button", UpsellBundleButton);
}

let UpsellBundleTotals = class extends HTMLElement {
  constructor() {
    super();

    this.percentage = 0;
    this.discount = 0;
    this.subtotal = 0;
    this.totals = 0;

    this.calculateTotals();
  }
  connectedCallback() {
    document.documentElement.addEventListener(
      "upsell-bundle:updated",
      this._onUpsellUpdated.bind(this),
    );
  }
  disconnectedCallback() {
    document.documentElement.removeEventListener(
      "upsell-bundle:updated",
      this._onUpsellUpdated.bind(this),
    );
  }
  _onUpsellUpdated(event) {
    this.calculateTotals();
  }

  calculateTotals() {
    const choosenProducts = document.querySelectorAll(
      ".db-0015-upsell-slider-product.active",
    );

    let fullPrice = 0;
    choosenProducts.forEach((product) => {
      const priceEl = product.querySelector(
        ".db-0015-upsell-slider-product-price",
      );
      const cleanPrice = getPrice(priceEl) || 0;
      fullPrice += cleanPrice;
    });

    let discountValue = getValue() || 0;
    const reducedValue = fullPrice * (1 - discountValue / 100);
    const overallDiscount = fullPrice - reducedValue;

    const finishedFull = transformPrice(fullPrice);
    const finishedReduced = transformPrice(reducedValue);
    const finishedDiscount = transformPrice(overallDiscount);

    // DOM update
    const reducedEl = this.querySelector(
      ".db-0015-upsell-footer-price-reduced",
    );
    const fullEl = this.querySelector(".db-0015-upsell-footer-price-full");
    const compareEl = this.querySelector("[data-compare-totals]");
    const offerTextEl = this.querySelector(
      ".db-0015-upsell-footer-price-offer span",
    );

    if (reducedEl) {
      reducedEl.textContent = finishedReduced + " €";
    }
    if (fullEl) {
      fullEl.textContent = finishedFull + " €";
    }
    if (compareEl) {
      compareEl.textContent = finishedDiscount + " €";
    }
    if (offerTextEl) {
      offerTextEl.textContent = `Spare ${finishedDiscount} €`;
    }
  }
};
if (!window.customElements.get("upsell-bundle-totals")) {
  window.customElements.define("upsell-bundle-totals", UpsellBundleTotals);
}

//initial
popupFunction();
badgeOffer();
upsellProduct();

// After initial sync, check sold-out notices
document.querySelectorAll("upsell-bundle-product[data-type='variant']").forEach((el) => {
  const notice = el.querySelector("[data-sold-out]");
  if (!notice) return;
  const selects = Array.from(el.querySelectorAll("select"));
  const hasUnavailable = selects.some((select) => {
    if (select.value === "0") return false;
    const opt = select.querySelector(`option[value="${select.value}"]`);
    return opt && opt.disabled;
  });
  const variantSoldOut = el.variant && !el.variant.available;
  notice.hidden = !hasUnavailable && !variantSoldOut;
});

//priceCalc();
//atcOffer();
//productFunctions();

// Color sync: When user changes color on the main product, update all upsell variant products
let _db0015LastColor = null;
document.addEventListener("variant:change", (event) => {
  const { product, variant } = event.detail;
  if (!product || !variant) return;

  // Find color option index in main product
  const colorOptionIndex = product.options.findIndex(
    (o) => (typeof o === "string" ? o : o.name) === "Farbe",
  );
  if (colorOptionIndex === -1) return;

  const newColor = variant[`option${colorOptionIndex + 1}`];
  if (!newColor) return;

  // Skip if color hasn't changed (covers initial fire)
  if (newColor === _db0015LastColor) return;
  const isInitial = _db0015LastColor === null;
  _db0015LastColor = newColor;
  if (isInitial) return; // upsellProduct() already handled the initial sync

  // Update all upsell variant products
  document.querySelectorAll('upsell-bundle-product[data-type="variant"]').forEach((el) => {
    const colorSelect = Array.from(el.querySelectorAll("select")).find(
      (s) => s.dataset.type === "farbe",
    );
    if (!colorSelect) return;

    const hasOption = Array.from(colorSelect.options).some((o) => o.value === newColor);
    if (!hasOption || colorSelect.value === newColor) return;

    // Set value and fire change so existing _onSelectChanged handles image + variant matching
    colorSelect.value = newColor;
    colorSelect.dispatchEvent(new Event("change", { bubbles: true }));
  });
});